import React from 'react';
import PropTypes from 'prop-types';

import { Hidden, Visible } from 'components/Grid';

import {
  Section,
  Container,
  Text,
} from './styles';

const TextBanner = ({ children }) => (
  <Section>
    <Container flex align="center" justify="center">
      <Hidden xs>
        <Text>{children}</Text>
      </Hidden>
      <Visible xs>
        <Text.xs>{children}</Text.xs>
      </Visible>
    </Container>
  </Section>
);

TextBanner.propTypes = {
  children: PropTypes.string.isRequired,
};

export default TextBanner;
